<template>
<div>
  <el-tabs type="border-card" v-model="tabSelected" v-if="consulta">

    <el-tab-pane label="Imprimir ASO" name="tab-aso">
      <span slot="label"><i class="fa fa-print"></i> Imprimir ASO</span>
      <Aso :consulta="consulta"/>
    </el-tab-pane>

    <el-tab-pane label=" Imprimir Ficha Clínica" name="tab-femo">
      <span slot="label"><i class="fa fa-print"></i> Imprimir Ficha Clínica</span>
      <Femo :consulta="consulta"/>
    </el-tab-pane>

    <el-tab-pane label=" Liberar ASO" name="tab-liberar">
      <span slot="label"><i class="fa fa-lock"></i> Liberar ASO</span>
      <Liberar :consulta="consulta"/>
    </el-tab-pane>

    <el-tab-pane label="Cancelar Consulta" name="tab-cancelar" v-if="!consulta || (consulta && consulta.tipo_status && consulta.tipo_status.id != 66 && consulta.tipo_status.id != 57 && consulta.tipo_status.id != 58)">
      <span slot="label"><i class="fa fa-window-close"></i> Cancelar Consulta</span>
      <Cancelar :consulta="consulta"/>
    </el-tab-pane>

  </el-tabs>
</div>
</template>

<script>

import Aso from './aso'
import Femo from './femo'
import Liberar from './liberar'
import Cancelar from './cancelar'

export default {
    name: 'aso',
    components:{Aso,Femo,Liberar,Cancelar},
    mixins:[],
    props:{
      consulta:{
        type: Object,
        default: null
      }
    },
    watch:{
      'consulta.id'(){
        this.tabSelected="tab-aso";
      },
      'consulta.tipo_status.id'(){
        this.tabSelected="tab-aso";
      },
    },
    data () {
      return{
        tabSelected: 'tab-aso'
      }
    },

    created(){
    },
    mounted(){

      this.$events.on('consulta-liberado', eventData => {
        this.tabSelected="tab-aso";
      });
    },

    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// index.vue?16cd8d1c